import type { FC } from 'react';
import { Routes, Route } from 'react-router-dom';
import { DashboardShell } from './components/layout';
import { FraudReviewPage } from './pages/FraudReviewPage';
import type { Customer } from './types';

// Mock customer for demo
const mockCustomer: Customer = {
  id: 'cust-123',
  businessName: 'Acme Corporation LLC',
  onboardingStatus: 'approved',
  isOnboarded: true,
  ledgerBalanceCents: 1500000,
  ledgerBalanceDollars: 15000,
};

const DashboardHome: FC = () => {
  return (
    <DashboardShell
      customer={mockCustomer}
      pageTitle="Dashboard"
    >
      <div className="space-y-6">
        {/* Welcome Card */}
        <div className="bg-white rounded-lg shadow p-6">
          <h2 className="text-lg font-semibold text-gray-900 mb-2">
            Welcome to PayGuard
          </h2>
          <p className="text-gray-600">
            Your fraud-protected payment platform. Manage payments, vendors, and monitor
            transactions all in one place.
          </p>
        </div>

        {/* Stats Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <div className="bg-white rounded-lg shadow p-6">
            <p className="text-sm font-medium text-gray-500 uppercase">Total Payments</p>
            <p className="text-3xl font-bold text-gray-900 mt-2">$125,000</p>
          </div>
          <div className="bg-white rounded-lg shadow p-6">
            <p className="text-sm font-medium text-gray-500 uppercase">Pending Review</p>
            <p className="text-3xl font-bold text-yellow-600 mt-2">3</p>
          </div>
          <div className="bg-white rounded-lg shadow p-6">
            <p className="text-sm font-medium text-gray-500 uppercase">Active Vendors</p>
            <p className="text-3xl font-bold text-blue-600 mt-2">24</p>
          </div>
        </div>

        {/* Recent Activity */}
        <div className="bg-white rounded-lg shadow">
          <div className="px-6 py-4 border-b border-gray-200">
            <h3 className="text-lg font-medium text-gray-900">Recent Activity</h3>
          </div>
          <div className="divide-y divide-gray-200">
            <div className="px-6 py-4">
              <p className="text-sm text-gray-500">No recent activity</p>
            </div>
          </div>
        </div>
      </div>
    </DashboardShell>
  );
}

const App: FC = () => {
  return (
    <Routes>
      <Route path="/" element={<DashboardHome />} />
      <Route path="/fraud-review" element={<FraudReviewPage />} />
      <Route path="*" element={<div>Not Found</div>} />
    </Routes>
  );
}

export default App;
